import axios from 'services/apiClient';
import { checkLibraryItemRemoved, LibraryItemAll } from 'services/singles';
import useSWR from 'swr';

export const getLibraryItem = async (libraryItemId?: string) => {
  if (!libraryItemId) {
    return null;
  }

  const { data } = await axios.get<LibraryItemAll>(
    `${process.env.REACT_APP_LIBRARY_ITEM_IMAGE}/${libraryItemId}/data/libraryitem.json`,
    {
      timeout: 10000
    }
  );

  if (checkLibraryItemRemoved(data?.status)) {
    return null;
  }

  return data;
};

const useLibraryItemDetails = (libraryItemId?: string) => {
  const { data, isValidating, error } = useSWR(
    libraryItemId ? `library_item_details/${libraryItemId}` : null,
    () => (libraryItemId ? getLibraryItem(libraryItemId) : null),
    {
      revalidateOnFocus: false,
      refreshWhenOffline: false
    }
  );

  return {
    libraryItemDetails: data ?? undefined,
    loading: !data && isValidating,
    error
  };
};

export default useLibraryItemDetails;
